import { useTransactionsSpinnerStore } from 'lib/hooks/useTransactionsSpinnerStore'
import gear from './gear.gif'
import './spinner.css'

export const SpinnerIcon = (): JSX.Element => {
  const { setOpenSpinnerDrawer, showSpinnerLoading } = useTransactionsSpinnerStore()

  const toggleDrawer = () => {
    setOpenSpinnerDrawer(true)
  }

  return (
    <>
      {showSpinnerLoading && (
        <div onClick={toggleDrawer} className="transactions-spinner-icon-container">
          <i className="fa-solid fa-caret-left spinner-icon"></i>
          <div className="d-flex flex-column justify-content-center text-center align-items-center">
            <img src={gear} alt="Loading" />
            <span className="open-for-details">Open for details</span>
          </div>
        </div>
      )}
    </>
  )
}
